import type { AdminV2LiveAlert } from "@/types/adminV2";

/** Activity has a shared LIST contract; note collections have exact record IDs.
 * Invalidation changes freshness, never the server's permission projection. */
export const getLiveAlertRelatedRecordTags = (
  alert: Pick<AdminV2LiveAlert, "organisationId" | "personId" | "userId">,
) => [
  { type: "AdminV2CrmTimeline" as const, id: "LIST" },
  ...(alert.organisationId
    ? [
        {
          type: "AdminV2CrmRecordInternalNotes" as const,
          id: `organisation:${alert.organisationId}`,
        },
      ]
    : []),
  ...(alert.personId
    ? [
        {
          type: "AdminV2CrmRecordInternalNotes" as const,
          id: `person:${alert.personId}`,
        },
      ]
    : []),
  ...(alert.userId && alert.organisationId
    ? [
        {
          type: "AdminV2CrmUserInternalNotes" as const,
          id: `${alert.userId}:${alert.organisationId}`,
        },
      ]
    : []),
];
